import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { CarrierSettings } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface CarrierSettingsModel {
  carrierSettingsMap: Record<string, CarrierSettings>;
  setCarrierSettings: Action<CarrierSettingsModel, CarrierSettings[]>;
  setCarrierSetting: Action<CarrierSettingsModel, CarrierSettings>;
  fetchCarrierSettingsLoading: boolean;
  setFetchCarrierSettingsLoading: Action<CarrierSettingsModel, boolean>;
  fetchCarrierSettings: Thunk<CarrierSettingsModel, void, Injections, StoreModel, Promise<void>>;
  fetchCarrierSettingsFailure: Action<CarrierSettingsModel, ApplicationErrorOptions>;
}

export const carrierSettingsModel: CarrierSettingsModel = {
  carrierSettingsMap: {},
  setCarrierSettings: action((state, carrierSettings) => {
    const carrierSettingsMap = carrierSettings.reduce<Record<string, CarrierSettings>>((acc, curr) => {
      acc[curr.carrierSettingsId] = curr;
      return acc;
    }, {});
    state.carrierSettingsMap = carrierSettingsMap;
  }),
  setCarrierSetting: action((state, carrierSetting) => {
    state.carrierSettingsMap[carrierSetting.carrierSettingsId] = carrierSetting;
  }),
  fetchCarrierSettingsLoading: false,
  setFetchCarrierSettingsLoading: action((state, isLoading) => {
    state.fetchCarrierSettingsLoading = isLoading;
  }),
  fetchCarrierSettings: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchCarrierSettingsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchCarrierSettings();
      actions.setCarrierSettings(response);
      actions.setFetchCarrierSettingsLoading(false);
      return response;
    } catch (error) {
      actions.fetchCarrierSettingsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchCarrierSettingsLoading(false);
      return error;
    }
  }),
  fetchCarrierSettingsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default carrierSettingsModel;
